export default __webpack_public_path__ + "static/media/icons8-python.9777d0c0.svg";